import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "dropdown-panel" }
const _hoisted_2 = { class: "dropdown-panel-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "dropdown-panel-label h5" }
const _hoisted_6 = {
  key: 0,
  class: "dropdown-panel-content"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$props.hideToggle)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "dropdown-panel-button",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleDropdownPanel && $options.toggleDropdownPanel(...args)))
          }, [
            ($data.isDropdownPanelOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa-solid', 'fa-minus'] })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fasr', 'fa-plus'] })
                ])),
            _createElementVNode("div", _hoisted_5, _toDisplayString($data.buttonLabel + $props.additionalLabel), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "header-content")
    ]),
    ($data.isDropdownPanelOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "content")
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}